import { CompanyAttributes } from '@albatrosdeveloper/ave-models-package';
import BusinessPartnerTypeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-type/business-partner-type.entity';
import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatRowDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CompanyService } from '../../configuration/company/company.service.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { BusinessPartnerTypeService } from './business-partner-type.service';
import { ICreateBusinessPartnerType } from './interfaces/create-business-partner-type.interface';
import { IUpdateBusinessPartnerType } from './interfaces/update-business-partner-type.interface';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { FilterSectionComponent } from 'app/common/components/filter-section/filter-section.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { IRequestResult } from 'app/common/interfaces';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";



@Component({
  selector: 'app-business-partner-type',
  standalone: true,
  templateUrl: './business-partner-type.component.html',
  styleUrl: './business-partner-type.component.scss',
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectModule,
    StatusFiltersComponent,
    FilterComponent,
    FilterSectionComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
})

export class BusinessPartnerTypeComponent implements AfterViewInit, OnDestroy {
  displayedColumns: string[] = ["name", "company", "statusId", "actions"];
  currentCreateBusinessPartnerType: ICreateBusinessPartnerType = this.initializeCreateBusinessPartnerType();
  currentUpdateBusinessPartnerType: BusinessPartnerTypeAttributes | undefined;

  companyList: CompanyAttributes[] = [];
  companyFilterList: CompanyAttributes[] = [];

  dataSource: BusinessPartnerTypeAttributes[] = [];
  searchQuery = '';
  totalItems = 0;
  pageSize = 50;
  pageIndex = 0;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  //BUSCADOR
  searchSubscription: Subscription;

  // Status Filter Properties
  selectedStatuses: number[] = [1, 0]; // Default to show both active and inactive

  // Company Filter Properties
  form: FormGroup;
  
  constructor(
    private readonly companyService: CompanyService,
    private readonly businessService: BusinessPartnerTypeService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
  ) {
    // Initialize form for filters
    this.form = this.fb.group({
      companyId: [null]
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private initializeCreateBusinessPartnerType(): ICreateBusinessPartnerType {
    return { code: '', name: ""};
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount(); 
  }

  // getSelectedCompanyCodes(selectedCompanyIds: string[]): number[] {
  //   return selectedCompanyIds.map(
  //     (id) =>
  //       this.companyList.find((group) => group._id.toString() === id)
  //         ?.id
  //   );
  // }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" = this.sort.direction === "asc" ? "ASC" : "DESC";

    this.businessService
      .findAllWithCount({
        currentPage: pageIndex, 
        limitPerPage: this.pageSize, 
        search: this.searchQuery, 
        sort: sortField, 
        sortDirection: sortDirection,
        // Add filter parameters
        status: this.selectedStatuses.length ? this.selectedStatuses : null,
      })
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof BusinessPartnerTypeAttributes {
    const validSortFields: (keyof BusinessPartnerTypeAttributes)[] = ["code", "name", "statusId"];
    return validSortFields.includes(this.sort.active as keyof BusinessPartnerTypeAttributes) ? (this.sort.active as keyof BusinessPartnerTypeAttributes) : "code";
  }



  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: BusinessPartnerTypeAttributes): string {
    return item._id.toString();
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }


  openCreateModal(): void {
    this.currentCreateBusinessPartnerType = this.initializeCreateBusinessPartnerType();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createBusinessPartnerType());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(materialBrand: BusinessPartnerTypeAttributes): void {
    this.currentUpdateBusinessPartnerType = { ...materialBrand };
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateBusinessPartnerType(materialBrand._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createBusinessPartnerType(): void {
    this.businessService.create(this.currentCreateBusinessPartnerType).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
        this.dialogRefAdd.close()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateBusinessPartnerType(id: string): void {
    if (this.currentUpdateBusinessPartnerType) {
      const updatedBusinessPartnerType: IUpdateBusinessPartnerType = { 
         ...this.currentUpdateBusinessPartnerType };

      this.businessService.update(id, updatedBusinessPartnerType).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.findAllWithCount();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, materialBrand: BusinessPartnerTypeAttributes): void {
    const originalStatusId = materialBrand.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBusinessPartnerType = { ...materialBrand, statusId: updatedStatusId };

    this.businessService.update(materialBrand._id.toString(), updatedBusinessPartnerType).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        materialBrand.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
      }
    });
  }

  openDeleteDialog(materialBrand: BusinessPartnerTypeAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: materialBrand, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(materialBrand._id.toString()));
  }

  delete(id: string): void {
    this.businessService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }
  
  // Status Filter Methods
  applyStatusFilter(): void {
    this.paginator.pageIndex = 0; // Reset to first page when filtering
    this.findAllWithCount();
  }

  // Company Filter Methods
  onFilterEvent(event: any): void {
    this.paginator.pageIndex = 0; // Reset to first page when filtering
    this.findAllWithCount();
  }

  onCleanEvent(event: any): void {
    this.form.patchValue({
      companyId: null
    });
    this.paginator.pageIndex = 0;
    this.findAllWithCount();
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}

